import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { groupLoginActions } from './login.actions';
import { groupLoginInit } from './login.dtos';

const groupLoginReducer = combineReducers({
  loginRequest: createReducer(groupLoginInit)
    .handleAction(
      [
        groupLoginActions.request,
      ], (state, action) => action.payload),

  loginSuccess: createReducer('')
    .handleAction(
      [
        groupLoginActions.success,
      ], (state, action) => action.payload),

  loginError: createReducer('')
    .handleAction(
      [
        groupLoginActions.failure,
      ], (state, action) => action.payload)
});

export default groupLoginReducer;